import i18n from '../../../common/i18n';

export function translateServerError(code: string) {
    if (code === 'ERROR_ANALYSIS_TITLE_SIZE') return i18n('nui.betbook.analysis-title-size');
    if (code === 'ERROR_ANALYSIS_TEXT_SIZE') return i18n('nui.betbook.analysis-text-size');
    if (code === 'ERROR_MAX_ANALYSIS_POSTS') return i18n('nui.betbook.analysis-max-posts');
    if (code === 'ANALYSIS_SHARE_LIMIT_REACHED') return i18n('nui.betbook.analysis.share.limit.reached');
    if (code === 'CONTAINS_SAME_ANALYSIS') return i18n('nui.betbook.contains.same.analysis');
    if (code === 'ERROR_BLOG_TITLE_SIZE') return i18n('nui.betbook.blog-title-size');
    if (code === 'ERROR_BLOG_TEXT_SIZE') return i18n('nui.betbook.blog-text-size');
    if (code === 'ERROR_MAX_BLOG_POSTS') return i18n('nui.betbook.blog-max-posts');
    if (code === 'ERROR_TICKET_TITLE_SIZE') return i18n('nui.betbook.ticket-title-size');
    if (code === 'ERROR_TICKET_TEXT_SIZE') return i18n('nui.betbook.ticket-text-size');
    if (code === 'ERROR_TICKET_ALREADY_PUBLISHED') return i18n('nui.betbook.ticket-already-published');
    if (code === 'ERROR_MAX_TICKET_POSTS') return i18n('nui.betbook.ticket-max-posts');
    if (code === 'ERROR_PICK_CLOSED') return i18n('nui.betbook.pick-closed');
    if (code === 'ERROR_TICKET_AND_BET_DONT_CORRELATE') return i18n('nui.betbook.post-ticket-bet-correlation');
    if (code === 'ERROR_TICKET_ODDS_TOO_HIGH') return i18n('nui.betbook.ticket-max-odds');
    if (code === 'ERROR_BETS_EXPIRED') return i18n('nui.betbook.ticket-bets-expired');
    if (code === 'ERROR_CONTAINS_LINKS') return i18n('nui.betbook.contains-links');
    if (code === 'ERROR_FORBIDDEN_WORDS') return i18n('nui.betbook.forbidden-words');
    if (code === 'ERROR_NOT_EDITABLE') return i18n('nui.betbook.post-not-editable');
    if (code === 'ERROR_MATCH_ALREADY_STARTED') return i18n('nui.betbook.analysis-match-started');
    if (code === 'ERROR_INVALID_BET_SELECTION_ID') return i18n('nui.betbook.post-bet-selection-invalid');
    if (code === 'NOT_ALLOWED') return i18n('nui.betbook.post.not-allowed');
    if (code === 'AUTHENTICATION_ERROR') return i18n('nui.betbook.post.authentication-error');
    if (code === 'NOT_FOUND') return i18n('nui.betbook.not-found');
    if (code === 'CANNOT_LIKE_YOURSELF') return i18n('nui.betbook.cannot-like-yourself');
    if (code === 'IMPROPER_CONTENT') return i18n('nui.betbook.improper-content');
    if (code === 'NOT_ENABLED') return i18n('nui.betbook.not-enabled');

    return i18n('nui.jsp.error.header');
}
